import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import message from './message'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    message,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
})
